export default "__VITE_ASSET__1G5ETLhC$bx4zEx8uXqaGw__"